<template>
  <div class="ws-static-locale-read">
    <v-form
      class="ws-static-locale-read__form"
      v-if="showFields"
    >
      <v-row>
        <v-col>名詞</v-col>
        <v-col>翻譯</v-col>
      </v-row>
      <v-row
        v-for="(languItem,languIndex) in showFields"
        :key="languIndex"
      >
        <v-col>
          {{languItem.label}}
        </v-col>
        <v-col>
          <div
            v-if="$_alert(languItem.translate)"
            class="ws-static-locale-read__form__alert"
          >
            {{$_alert(languItem.translate)}}
          </div>
          {{languItem.translate}}
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
export default {
  props: {
    showFields: {
      type: Array,
    },
  },
  methods: {
    $_alert(item) {
      if (item.indexOf("{") != -1 || item.indexOf("}") != -1) {
        return `請勿將'{ }'內的文字刪除`;
      } else {
        return null;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-static-locale-read.scss";
</style>